import { useState, useEffect, useCallback } from 'react';
import InvestorMetricsService from '../../../../../services/investor-metrics.service';

export const useWorkflowMetrics = ({ dateRange = '30d', organization = null }) => {
  const [data, setData] = useState({
    coverageChecksByRole: null,
    featureModuleAdoption: null,
    apiCallFrequency: null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const [roleChecks, moduleAdoption, apiFrequency] = await Promise.all([
        InvestorMetricsService.getCoverageChecksByRole({ organization, dateRange }),
        InvestorMetricsService.getFeatureModuleAdoption({ organization, dateRange }),
        InvestorMetricsService.getApiCallFrequency({ organization, dateRange }),
      ]);

      setData({
        coverageChecksByRole: roleChecks,
        featureModuleAdoption: moduleAdoption,
        apiCallFrequency: apiFrequency,
      });
    } catch (err) {
      console.error('Error fetching workflow metrics:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [dateRange, organization]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const refetch = useCallback(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch };
};
